'use client';

import { usePathname } from '@/i18n/routing';
import { publichnyjPut } from '@/lib/public-path';

/**
 * Публичный путь страницы, каким его видит посетитель.
 *
 * На домене продукта middleware переписывает `/app/json-editor` во
 * внутренний `/<locale>/datahunter/app/json-editor`, и `usePathname`
 * возвращает именно внутренний вид: он ничего не знает о переписывании.
 * Если отдать такой путь ссылке, получится `/datahunter/datahunter/...`,
 * то есть 404 при смене языка.
 *
 * Поэтому внутренние ветки здесь срезаем (`lib/public-path.ts`). Локали в
 * значении уже нет: её убирает навигация next-intl.
 */
export function usePublicPathname(): string {
  return publichnyjPut(usePathname());
}
